//SHORTCUT TO DIRECTLY IMPORT COMPONENTS PATH INTO FILE IS "cTRL+SPACE"
//SHORTCUT: TO DEFAULT TEMPLATE IS rafce
import './App.css';
import Footer from './components/Footer/Footer';
import Hero from './components/Hero/Hero';
import Join from './components/Join/Join';
import Plans from './components/Plans/Plans';
import Program from './components/Programs/Programs';
import Reasons from './components/Reasons/Reasons';
import Testimonials from './components/Testimonials/Testimonials';
 
function App() {
  return (
    <div className="App">
           <Hero/>
           <Program/>
           <Reasons/>
           <Plans/>
           <Testimonials/>
           <Join/> 
           <Footer/> 
    </div>
  );
}

export default App;
